// src/components/TokenRefresher.jsx
import { useEffect } from 'react';
import useStore from '../store/index';

export default function TokenRefresher() {
  const { accessToken, refreshUserToken } = useStore();

  useEffect(() => {
    if (!accessToken) return;

    const checkExpiry = () => {
      try {
        const payload = JSON.parse(atob(accessToken.split('.')[1]));
        const exp = payload.exp * 1000;
        if (Date.now() > exp - 60000) {
          refreshUserToken();
        }
      } catch (e) {
        console.warn('Invalid token format');
      }
    };

    const interval = setInterval(checkExpiry, 30000);
    return () => clearInterval(interval);
  }, [accessToken, refreshUserToken]);

  return null;
}